// Near-duplicate name detection for the draw flow. Pure + unit-tested.
// Identity elsewhere is matched case-insensitively and whitespace-collapsed;
// this adds a fuzzy layer to catch typos at entry time (e.g. Jeevesy vs Jeevesyy).
// ESM named exports — imported from JSX bundled by Rollup, like src/share.js.

export const normalizeName = (s) =>
  String(s || '').trim().toLowerCase().replace(/\s+/g, ' ');

export function levenshtein(a, b) {
  if (a === b) return 0;
  const m = a.length, n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  let prev = Array.from({ length: n + 1 }, (_, i) => i);
  let curr = new Array(n + 1);
  for (let i = 1; i <= m; i++) {
    curr[0] = i;
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      curr[j] = Math.min(prev[j] + 1, curr[j - 1] + 1, prev[j - 1] + cost);
    }
    [prev, curr] = [curr, prev];
  }
  return prev[n];
}

// Closest existing name that is a NEAR but not EXACT match (exact = same player,
// handled by the picker/server). Conservative to limit false positives: edit
// distance <= 1, OR one normalised name is a prefix of the other with a length
// difference <= 2. Returns the existing display name, or null.
export function closestExistingName(candidate, names = []) {
  const c = normalizeName(candidate);
  if (!c) return null;
  let best = null;
  let bestDist = Infinity;
  for (const name of names) {
    const n = normalizeName(name);
    if (!n || n === c) continue; // exact handled elsewhere
    const dist = levenshtein(c, n);
    const prefix = (n.startsWith(c) || c.startsWith(n)) && Math.abs(n.length - c.length) <= 2;
    if ((dist <= 1 || prefix) && dist < bestDist) { best = name; bestDist = dist; }
  }
  return best;
}
